export class Routes {
  public static HOME_ROUTE = 'home';
  public static INFO_ROUTE = 'info';
  public static LOGOUT_ROUTE = 'logout';
  public static LOGIN_ROUTE = 'login';
  public static GLOSSAR_ROUTE = 'glossar';
  public static SELECT_PERSONA_ROUTE = 'selectPersona';
  public static ROUTE_AFTER_PERSONA_SELECT = Routes.LOGIN_ROUTE;
}
